import { Box, Card, Skeleton, Stack } from "@mui/material";

const OrganizationMenuSkeleton = () => {
  return (
    <Card sx={{ borderRadius: 3, overflow: "hidden", height: "100%" }}>
      <Box sx={{ bgcolor: "#06175D", pt: "24px", px: "24px", pb: "16px" }}>
        <Stack spacing={5}>
          <Skeleton
            variant="rounded"
            width={70}
            height={24}
            sx={{ bgcolor: "rgba(255, 255, 255, 0.15)" }}
          />
          <Skeleton
            variant="text"
            width="60%"
            height={32}
            sx={{ bgcolor: "rgba(255, 255, 255, 0.15)" }}
          />
        </Stack>
      </Box>
      <Stack sx={{ pt: "16px", px: "24px", pb: "24px" }} spacing={3}>
        <Skeleton variant="text" width="85%" height={20} />
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rounded" width={56} height={36} />
          <Skeleton variant="rounded" width={40} height={36} />
        </Stack>
      </Stack>
    </Card>
  );
};

export default OrganizationMenuSkeleton;
